// Mesmo endereço para o login e para a Ajuda dos quatro perfis.
const PADRAO = "https://drive.google.com/file/d/1ueCkVdvlr1PD89vUWmgA9Kgy-FBzGhvL/view";
function obterEndereco() {
  try { return (process.env.REACT_APP_GUIA_UTILIZACAO_URL || PADRAO).trim(); }
  catch { return PADRAO; }
}
export const GUIA_UTILIZACAO_URL = obterEndereco();
